import { useIonModal } from '@ionic/react'

import { ProgramTaskGroupFilterModal } from '@apps-common/apps/portal/pages/units/pages/program-tasks/modals'
import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { DEFAULT_ACTION_BUTTON_COLOR_CLASSES } from '@apps-common/config/colors'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'

export const TasksFilterButton: React.FC = () => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(ProgramTaskGroupFilterModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes={DEFAULT_ACTION_BUTTON_COLOR_CLASSES}
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
    />
  )
}
